import { t } from '@/i18n/utils'

/**
 * Home 页面公共配置
 * 所有品牌共享的文案
 */

export const homeCommonConfig = {
  texts: {
    get searchPlaceholder() { return t('SearchBox') },
    get seeAll() { return t('SeeAll') },
    get loading() { return `${t('Loading')}...` },
    get noMore() { return `${t('NoMore')} ~` },
    get play() { return t('PlayButton') },
    get playAgain() { return t('dramaPlayAgain') },
    get makeTheChoice() { return t('dramaMakeChoice') },
    get storyLine() { return t('dramaStoryLine') },
    get characterProfile() { return t('dramaCharacterProfile') },
    get characterHighlights() { return t('dramaCharacterHighlights') },
    get dramaBannerDesc() { return t('dramaBannerDesc') },
    get more() { return t('More') },
    continueEp: (ep: number | string) => t('dramaContinueEp', { ep }),
    episodeOf: (ep: number | string, total: number | string) => t('dramaEpisodeOf', { ep, total }),
    endingsUnlocked: (count: number | string) => t('dramaEndingsUnlocked', { count }),
  },
}

/**
 * 逍遥联动配置
 * 只在指定域名下显示逍遥图标
 */
export const xiaoyaoConfig = {
  // 允许显示逍遥图标的域名列表
  allowedDomains: [
    'book-test.oceread.com',
    'xiaoyao-book.oceread.com',
    // 'localhost:3000',
  ],
}
